// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wpg1","type":"styles_type__2xmGH","choices":"styles_choices__Pg69w"};